"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Tile = _interopRequireDefault(require("../Tile"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _ShowAllTiles = _interopRequireDefault(require("../ShowAllTiles"));

var _TileTray = _interopRequireDefault(require("../TileTray"));

var _constant = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constants = require("../Tile/constants");

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _productTiles = _interopRequireDefault(require("./product.tiles.proptypes"));

var _constants2 = require("./constants");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "ProductTiles__Wrapper",
  componentId: "sc-tzuoe4-0"
})(["width:100%;position:relative;"]);

var ProductTilesWrapperDesktop = _styledComponents.default.div.withConfig({
  displayName: "ProductTiles__ProductTilesWrapperDesktop",
  componentId: "sc-tzuoe4-1"
})(["", " align-items:center;justify-content:space-between;position:relative;background:", ";z-index:", ";", "}", ""], function (_ref) {
  var noOfTiles = _ref.noOfTiles,
      device = _ref.device;
  return noOfTiles > 5 ? "display: flex;" : device === _constants2.DEVICE_TYPE.TABLET && "display: flex;";
}, function (props) {
  return props.background ? props.theme.backgroundColor[props.background] : props.theme.backgroundColor.default;
}, function (_ref2) {
  var zIndex = _ref2.zIndex;
  return zIndex || _constants2.ZINDEX;
}, function (_ref3) {
  var tileItemFlexDirection = _ref3.tileItemFlexDirection;
  return tileItemFlexDirection === 'column' && (0, _styledComponents.css)(["min-height:90px;"]);
}, function (_ref4) {
  var noOfTiles = _ref4.noOfTiles;
  return noOfTiles > 5 && (0, _styledComponents.css)([".tile-inner-wrapper{flex:1;}"]);
});

var ProductTilesWrapperMobile = _styledComponents.default.div.withConfig({
  displayName: "ProductTiles__ProductTilesWrapperMobile",
  componentId: "sc-tzuoe4-2"
})(["display:grid;grid-template-columns:1fr 1fr 1fr 1fr;justify-items:center;grid-row-gap:", ";"], _constants2.GRID_ROW_GAP);

var ScrollBehavior = (0, _styledComponents.css)(["scroll-behavior:smooth;::-webkit-scrollbar{display:none;}scrollbar-width:none;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;"]);

var ProductTilesSingleLineWrapperMobile = _styledComponents.default.div.withConfig({
  displayName: "ProductTiles__ProductTilesSingleLineWrapperMobile",
  componentId: "sc-tzuoe4-3"
})(["display:grid;grid-auto-flow:column;grid-auto-columns:calc( 100% / ", " );overflow:scroll;justify-items:center;", ";"], function (props) {
  return props.tileItemSingleRowGridColumns ? props.tileItemSingleRowGridColumns : '4.5';
}, ScrollBehavior);

var useWindowSize = function useWindowSize(wrapperRef) {
  var _useState = (0, _react.useState)([0]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    var updateSize = (0, _throttle.default)(function () {
      setSize([wrapperRef.current.offsetWidth]);
    }, 300);

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateSize);
    }

    updateSize();
    return function () {
      return typeof window !== 'undefined' ? window.removeEventListener('resize', updateSize) : null;
    };
  }, [wrapperRef]);
  return size;
};

var getTileDesktop = function getTileDesktop(index, data, props, animationType, isFirst, isLast, showArrow, device, gtmParameters, handleGtm, getProductData, shouldFireGTM) {
  var productTile = data.productTile,
      productID = data.productID;
  var customPropertiesTile = data.customPropertiesTile;
  var background = props.background,
      textColor = props.textColor,
      theme = props.theme,
      accessible = props.accessible,
      widgetFunction = props.widgetFunction,
      highlightTileByDeFaultId = props.highlightTileByDeFaultId,
      queryParamsPresent = props.queryParamsPresent,
      version = props.version,
      tileItemFlexDirection = props.tileItemFlexDirection,
      tileImageDesktopWidth = props.tileImageDesktopWidth,
      tileImageDesktopHeight = props.tileImageDesktopHeight;

  if (isLast && showArrow) {
    customPropertiesTile = _objectSpread(_objectSpread({}, customPropertiesTile), {}, {
      className: 'showAllTile'
    });
  }

  return /*#__PURE__*/_react.default.createElement(_Tile.default, {
    data: data,
    background: background,
    handleGtm: handleGtm,
    gtmParameters: gtmParameters,
    textColor: textColor,
    theme: theme,
    customProperties: _objectSpread(_objectSpread({}, customPropertiesTile), {}, {
      role: 'tab',
      'aria-label': "".concat(data.productTile, ". Actionable Left click or press enter to access.")
    }),
    accessible: accessible,
    animationType: animationType,
    isFirst: isFirst || undefined,
    isLast: isLast || undefined,
    index: index,
    widgetFunction: widgetFunction,
    deviceType: device,
    key: productTile,
    highlightTileByDeFaultId: highlightTileByDeFaultId,
    queryParamsPresent: queryParamsPresent,
    getProductData: getProductData,
    shouldFireGTM: shouldFireGTM,
    itemFlexDirection: tileItemFlexDirection,
    tileImageDesktopWidth: tileImageDesktopWidth,
    tileImageDesktopHeight: tileImageDesktopHeight,
    version: version,
    idConfig: {
      parentName: 'productTile',
      widgetName: productID,
      index: index
    }
  });
};

getTileDesktop.propTypes = _productTiles.default.propTypes;

var getTileMobile = function getTileMobile(index, data, props, device, gtmParameters, handleGtm, shouldFireGTM) {
  var customPropertiesTile = data.customPropertiesTile,
      productTile = data.productTile,
      productID = data.productID;
  var background = props.background,
      textColor = props.textColor,
      theme = props.theme,
      accessible = props.accessible,
      widgetFunction = props.widgetFunction,
      tileImageMobileWidth = props.tileImageMobileWidth,
      tileImageMobileHeight = props.tileImageMobileHeight;
  return /*#__PURE__*/_react.default.createElement(_Tile.default, {
    isMobile: true,
    handleGtm: handleGtm,
    gtmParameters: gtmParameters,
    data: data,
    background: background,
    textColor: textColor,
    theme: theme,
    customProperties: customPropertiesTile,
    accessible: accessible,
    widgetFunction: widgetFunction,
    deviceType: device,
    key: productTile,
    shouldFireGTM: shouldFireGTM,
    tileImageMobileWidth: tileImageMobileWidth,
    tileImageMobileHeight: tileImageMobileHeight,
    idConfig: {
      parentName: 'productTile',
      widgetName: productID,
      index: index
    }
  });
};

getTileMobile.propTypes = _productTiles.default.propTypes;

var addCustomProperty = function addCustomProperty(data, key, value) {
  var customData = {};
  customData[key] = value; // eslint-disable-next-line no-param-reassign

  data.customPropertiesTile = customData;
};

var getArrayDesktop = function getArrayDesktop(showAll, length, props, animationType, device, indexToSplit, gtmParameters, handleGtm, getProductData, shouldFireGTM, productTileData) {
  var tiles = []; // const { configObj } = props;
  // const { productTileDetails } = configObj;

  var showArrow = false;
  productTileData.forEach(function (item, index) {
    var isFirst = index === 0;
    var isLast = !!(index === length && !showAll);
    addCustomProperty(item, _constants2.DATA_OTHER_TAB, _constants2.OTHER_TAB);
    var tile = getTileDesktop(index >= indexToSplit ? index + 2 : index + 1, item, props, animationType, isFirst, isLast, showArrow, device, gtmParameters, handleGtm, getProductData, shouldFireGTM);
    tiles.push(tile);
  });
  return tiles;
};

var getArrayMobile = function getArrayMobile(props, device, gtmParameters, handleGtm, shouldFireGTM, singleRow) {
  var tiles = [];
  var configObj = props.configObj;
  var productTileDetails = configObj.productTileDetails;
  productTileDetails.forEach(function (item, index) {
    var tile = getTileMobile(index >= _constants2.INDEX_TO_SPLIT && !singleRow ? index + 2 : index + 1, item, props, device, gtmParameters, handleGtm, shouldFireGTM);
    tiles.push(tile);
  });
  return tiles;
};

var getIndexToSplit = function getIndexToSplit(length, noOfTiles, width) {
  var index = noOfTiles - 2;

  if (length > _constants2.MAX_TILES) {
    index = _constants2.INDEX_TO_SPLIT;
  }

  if (index > noOfTiles - 2) {
    index = noOfTiles - 2;
  }

  if (width > 600 && width <= 700) {
    index = 3;
  }

  return index;
};

var splitArrayDesktop = function splitArrayDesktop(arrayToDisplay, indexToSplit, showAllObject, props, animationType, device, gtmParameters, handleGtm, getProductData, shouldFireGTM) {
  var firstBatch = [];
  var secondBatch = [];
  var isLast = true;
  var showArrow = true;
  var isFirst = false;
  var showAllData = {
    productTile: showAllObject.label,
    iconUrl: showAllObject.icon,
    showSearchWidget: _constants2.TRUTHY,
    gtmProductID: showAllObject.productID,
    productID: _constants2.ShowAllProductId
  };
  addCustomProperty(showAllData, _constants2.DATA_SHOW_ALL, _constants2.SHOWALL_TAB);
  firstBatch = arrayToDisplay.slice(0, indexToSplit);
  var tile = getTileDesktop(indexToSplit + 1, showAllData, props, animationType, isFirst, isLast, showArrow, device, gtmParameters, handleGtm, getProductData, shouldFireGTM);
  firstBatch.push(tile);
  secondBatch = arrayToDisplay.slice(indexToSplit);
  return [firstBatch, secondBatch];
};

var splitArrayMobile = function splitArrayMobile(arrayToDisplay, showAllObject, props, device, gtmParameters, handleGtm, shouldFireGTM) {
  var firstBatch = [];
  var secondBatch = [];
  var indexToSplit = _constants2.INDEX_TO_SPLIT;
  var showAllData = {
    productTile: showAllObject.label,
    iconUrl: showAllObject.icon,
    showSearchWidget: _constants2.TRUTHY,
    productID: _constants2.ShowAllProductId,
    gtmProductID: showAllObject.productID
  };
  addCustomProperty(showAllData, _constants2.DATA_SHOW_ALL, _constants2.SHOWALL_TAB);
  firstBatch = arrayToDisplay.slice(0, indexToSplit);
  var tile = getTileMobile(indexToSplit + 1, showAllData, props, device, gtmParameters, handleGtm, shouldFireGTM);
  firstBatch.push(tile);
  secondBatch = arrayToDisplay;
  return [firstBatch, secondBatch];
};

var getTiltTray = function getTiltTray(openModal, mobile, theme, dataArray, showAll, isIE, onTrayBlurHandler, tileItemFlexDirection) {
  var categoryTextMobile = showAll.categoryTextMobile,
      categoryTextWeb = showAll.categoryTextWeb;
  var customProperties = {};
  customProperties[_constants2.DATA_MODAL] = _constants2.MODAL;
  return /*#__PURE__*/_react.default.createElement(_TileTray.default, {
    customProperties: customProperties,
    theme: theme,
    type: mobile ? _constants2.DEVICE_TYPE.MOBILE : _constants2.DEVICE_TYPE.DESKTOP,
    open: openModal,
    zIndex: _constants2.ZINDEX,
    onTrayBlur: onTrayBlurHandler
  }, /*#__PURE__*/_react.default.createElement(_ShowAllTiles.default, {
    theme: theme,
    isMobile: mobile,
    dataArray: dataArray,
    headingDesktop: categoryTextWeb,
    headingMobile: categoryTextMobile,
    isIE: isIE,
    tileItemFlexDirection: tileItemFlexDirection,
    otherTileSelector: "[".concat(_constants2.DATA_OTHER_TAB, "=").concat(_constants2.OTHER_TAB, "]")
  }));
};

var getProductTileWidget = function getProductTileWidget(isMobile, showAllFeature, arrayToDisplay, splitArrayToDisplay, theme, animationhandler, modalHandler, ref, openModal, wrapperRef, showAll, device, isIE, zIndex, singleRow, tileItemFlexDirection, tileItemSingleRowGridColumns, onTrayBlurHandler) {
  var customProperties = {
    className: 'product-tiles',
    id: 'airasia-product-tiles'
  };
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    onClick: function onClick(e) {
      return modalHandler(e);
    },
    ref: wrapperRef
  }, isMobile && (singleRow === true ? /*#__PURE__*/_react.default.createElement(ProductTilesSingleLineWrapperMobile, {
    ref: ref,
    tileItemSingleRowGridColumns: tileItemSingleRowGridColumns
  }, arrayToDisplay) : /*#__PURE__*/_react.default.createElement(ProductTilesWrapperMobile, {
    ref: ref
  }, !showAllFeature ? arrayToDisplay : splitArrayToDisplay[0])), !isMobile && /*#__PURE__*/_react.default.createElement(ProductTilesWrapperDesktop, (0, _extends2.default)({
    noOfTiles: arrayToDisplay.length,
    device: device,
    onClick: function onClick(e) {
      return animationhandler(e);
    },
    ref: ref,
    role: "tablist",
    zIndex: openModal && _constants2.ZINDEX || zIndex
  }, customProperties, {
    tileItemFlexDirection: tileItemFlexDirection
  }), !showAllFeature ? arrayToDisplay : splitArrayToDisplay[0]), getTiltTray(openModal, isMobile, theme, splitArrayToDisplay[1], showAll, isIE, onTrayBlurHandler, tileItemFlexDirection));
};

var getNumberOFTiles = function getNumberOFTiles(width) {
  var noOfTiles = Math.floor(width / _constants2.AVG_TILE_WIDTH);
  return noOfTiles;
};

var getShowAll = function getShowAll(singleRow, length, width, isMobile) {
  var ShowAll = false;
  var tilesCount = getNumberOFTiles(width);

  if (!isMobile) {
    if (length > _constants2.MAX_TILES || length >= tilesCount) {
      ShowAll = true;
    }
  } else if (!singleRow && length > _constants2.MAX_TILES) {
    ShowAll = true;
  }

  return ShowAll;
};

var getArrayToDisplay = function getArrayToDisplay(isMobile, showAll, length, props, animationType, device, indexToSplit, gtmParameters, handleGtm, getProductData, shouldFireGTM, productTileData, singleRow) {
  var array = [];

  if (!isMobile) {
    array = getArrayDesktop(showAll, length - 1, props, animationType, device, indexToSplit, gtmParameters, handleGtm, getProductData, shouldFireGTM, productTileData);
  } else {
    array = getArrayMobile(props, device, gtmParameters, handleGtm, shouldFireGTM, singleRow);
  }

  return array;
};

var getDefaultNumberOfTiles = function getDefaultNumberOfTiles(totalProductTilesCount, defaultProductTilesCount) {
  if (totalProductTilesCount <= defaultProductTilesCount) return totalProductTilesCount;
  return defaultProductTilesCount;
};

var getSplitArrayToDisplay = function getSplitArrayToDisplay(isMobile, arrayToDisplay, props, indexToSplit, animationType, device, gtmParameters, handleGtm, getProductData, shouldFireGTM) {
  var array = [];
  var configObj = props.configObj;
  var showAll = configObj.showAll;

  if (!isMobile) {
    array = splitArrayDesktop(arrayToDisplay, indexToSplit, showAll, props, animationType, device, gtmParameters, handleGtm, getProductData, shouldFireGTM);
  } else {
    array = splitArrayMobile(arrayToDisplay, showAll, props, device, gtmParameters, handleGtm, shouldFireGTM);
  }

  return array;
};

var usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
};

var getAnimation = function getAnimation(animation) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var value = usePrevious(animation);
  var animationType = _constants.ANIMATION_TYPE.noAnimation;

  if (value) {
    animationType = animation > value ? _constants.ANIMATION_TYPE.RTL : _constants.ANIMATION_TYPE.LTR;
  }

  return animationType;
};

var checkDevice = function checkDevice(device) {
  var isMobile = false;

  if (device === _constants2.DEVICE_TYPE.MOBILE) {
    isMobile = true;
  }

  return isMobile;
};

var ProductTiles = function ProductTiles(props) {
  var configObj = props.configObj,
      theme = props.theme,
      device = props.device,
      dataToggleModal = props.dataToggleModal,
      toggleModal = props.toggleModal,
      productEvent = props.productEvent,
      isIE = props.isIE,
      fireGtm = props.fireGtm,
      gtmConsumerName = props.gtmConsumerName,
      zIndex = props.zIndex,
      version = props.version,
      dynamicOrdering = props.dynamicOrdering,
      sessionKey = props.sessionKey,
      singleRow = props.singleRow,
      tileItemFlexDirection = props.tileItemFlexDirection,
      tileItemSingleRowGridColumns = props.tileItemSingleRowGridColumns;
  var productTileDetails = configObj.productTileDetails,
      showAll = configObj.showAll,
      gtmParameters = configObj.gtmParameters,
      enableGtm = configObj.enableGtm;

  var _ref5 = gtmParameters || {},
      event = _ref5.event,
      eventActionClick = _ref5.eventActionClick,
      eventActionView = _ref5.eventActionView,
      eventLabelView = _ref5.eventLabelView,
      eventLabelCardClick = _ref5.eventLabelCardClick;

  var _ref6 = gtmParameters || {},
      eventCategory = _ref6.eventCategory;

  var ref = (0, _react.useRef)(null);
  var wrapperRef = (0, _react.useRef)(null);

  var _useWindowSize = useWindowSize(wrapperRef),
      _useWindowSize2 = (0, _slicedToArray2.default)(_useWindowSize, 1),
      width = _useWindowSize2[0];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      animation = _useState4[0],
      setAnimation = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      openModal = _useState6[0],
      setOpenModal = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      productTileToShowFirst = _useState8[0],
      setProductTileToShowFirst = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      triggerProductTileClick = _useState10[0],
      setTriggerproductTileClick = _useState10[1];

  var _useState11 = (0, _react.useState)(true),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      shouldFireGTM = _useState12[0],
      setShouldFireGTM = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      isGtmViewLabelSet = _useState14[0],
      setIsGtmViewLabelSet = _useState14[1];

  var _useState15 = (0, _react.useState)(productTileDetails),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 1),
      productTileData = _useState16[0];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      isGtmShowAllViewLabelSet = _useState18[0],
      setIsGtmShowAllViewLabelSet = _useState18[1];

  var splitArrayToDisplay = [];
  var arrayToDisplay = [];

  var getProductData = function getProductData(dataReceived) {
    if (dynamicOrdering) {
      setProductTileToShowFirst(dataReceived);
      var indexToRemove;

      if (dataReceived && splitArrayToDisplay.length > 1) {
        var matchingObject = splitArrayToDisplay && splitArrayToDisplay[1].filter(function (obj) {
          return obj.key === dataReceived.productTile;
        });

        if (matchingObject.length !== 0) {
          indexToRemove = productTileData.indexOf(dataReceived);
          productTileData.splice(indexToRemove, 1);
          productTileData.unshift(dataReceived);
          setShouldFireGTM(false);
          setTriggerproductTileClick(true);
        } else setShouldFireGTM(true);
      }
    }
  }; // useEffect(() => {
  //   const sessionKeyName = `productTiles-${sessionKey}`;
  //   if (dynamicOrdering && sessionStorage.getItem(sessionKeyName)) {
  //     const productTilesFromStorage = JSON.parse(sessionStorage.getItem(sessionKeyName));
  //     setProductTileData(productTilesFromStorage);
  //   }
  // }, [dynamicOrdering, sessionKey]);


  (0, _react.useEffect)(function () {
    if (dynamicOrdering) {
      if (typeof document !== 'undefined' && productTileToShowFirst && triggerProductTileClick) {
        var firstProductTile = document.querySelector('[data-tile=other-tile]:first-child');
        firstProductTile.click(); // eslint-disable-next-line no-use-before-define

        removeShowAll(0); // const sessionKeyName = `productTiles-${sessionKey}`;
        // sessionStorage.setItem(sessionKeyName, JSON.stringify(productTileData));
      }

      setTriggerproductTileClick(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [productTileToShowFirst, productTileData, sessionKey]);
  var length = productTileData.length;
  var isMobile = checkDevice(device);
  var showAllFeature = getShowAll(singleRow, length, width, isMobile);
  var animationType = getAnimation(animation);
  var toggleAnimation = typeof document !== 'undefined' ? document.querySelector("[".concat(dataToggleModal, "=").concat(toggleModal, "]")) : null;

  if (productEvent && productEvent.target === toggleAnimation && animation !== null) {
    setAnimation(null);
  }

  var handleGtm = function handleGtm() {
    var productIdentity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var dataForGtm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eventLabelView;
    var click = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    eventCategory = eventCategory ? eventCategory.replace('{{consumername}}', gtmConsumerName || null) : null;
    var obj = {
      event: event,
      'eventDetails.category': eventCategory,
      'eventDetails.action': "".concat(click ? eventActionClick : eventActionView),
      'eventDetails.label': dataForGtm
    };

    if (productIdentity) {
      obj = _objectSpread(_objectSpread({}, obj), {}, {
        lineofbusiness: productIdentity
      });
    } // eslint-disable-next-line no-unused-expressions


    obj && fireGtm ? fireGtm(obj, enableGtm ? enableGtm.toLowerCase() : 'true') : null;
  };

  var animationhandler = function animationhandler(e) {
    var value = e.clientX;
    setAnimation(value);
  };

  var modalHandler = function modalHandler(e) {
    var modal = typeof document !== 'undefined' ? document.querySelector("[".concat(_constants2.DATA_MODAL, "=").concat(_constants2.MODAL, "]")) : null;

    if (e.target === modal) {
      setOpenModal(false);
      setAnimation(null);
    }

    if (version === 'v1') {
      if (ref.current && !ref.current.contains(e.target) && !e.target.closest('.showTray')) {
        setAnimation(null);
      }
    }
  };

  var removeShowAll = function removeShowAll(index) {
    var noOfTiles = getNumberOFTiles(width);
    var splitIndex = getIndexToSplit(length, noOfTiles, width);

    if (!isMobile && index < splitIndex) {
      setOpenModal(false);
    }
  };

  var buildGtmViewEventLabel = function buildGtmViewEventLabel(tilesArray, hasShowAll) {
    if (!tilesArray) {
      return;
    }

    var tileNames = '';
    var tileIndeces = '';
    var tilesArrayCopy = (0, _toConsumableArray2.default)(tilesArray);

    if (hasShowAll) {
      tilesArrayCopy.splice(-1, 1);
    }

    tilesArrayCopy.forEach(function (tile, idx) {
      if (!tile.props) {
        return;
      }

      var data = tile.props.data;
      var productID = data.productID;
      tileNames += "".concat(productID);
      tileIndeces += "".concat(idx + 1);

      if (idx + 1 < tilesArrayCopy.length) {
        tileNames += ' | ';
        tileIndeces += ' | ';
      }
    });
    var newLabel = eventLabelView.replace('{{tilesname}}', tileNames).replace('{{tilesorder}}', tileIndeces); // eslint-disable-next-line consistent-return

    return newLabel;
  };

  var showAllHandler = function showAllHandler() {
    setOpenModal(true);

    if (gtmParameters && !isGtmShowAllViewLabelSet && eventLabelView !== '') {
      setIsGtmShowAllViewLabelSet(true);
      var viewLabel = buildGtmViewEventLabel(arrayToDisplay, false);
      handleGtm(null, viewLabel, false);
    }
  };

  var visibilityChange = function visibilityChange() {
    setAnimation(null);
    setOpenModal(false);
  };

  var onTrayBlurHandler = function onTrayBlurHandler() {
    visibilityChange();
  };

  (0, _react.useEffect)(function () {
    var showAllTab;

    if (typeof document !== 'undefined') {
      if (showAllFeature) {
        showAllTab = document.querySelector("[".concat(_constants2.DATA_SHOW_ALL, "=").concat(_constants2.SHOWALL_TAB, "]"));
        var otherTab = document.querySelectorAll("[".concat(_constants2.DATA_OTHER_TAB, "=").concat(_constants2.OTHER_TAB, "]"));
        var closeModal = document.querySelector("[".concat(_constants2.DATA_CLOSE, "=").concat(_constants2.CLOSE_ICON, "]"));

        if (showAllTab) {
          showAllTab.addEventListener('click', showAllHandler);
          showAllTab.addEventListener('keydown', function (e) {
            return _utilities.default.keyDownHandler(e, showAllHandler, _constant.KEY_CODE.ENTER);
          });
        }

        if (otherTab) {
          var otherTabs = Array.prototype.slice.call(document.querySelectorAll("[".concat(_constants2.DATA_OTHER_TAB, "=").concat(_constants2.OTHER_TAB, "]")), 0);
          otherTabs.forEach(function (item, index) {
            item.addEventListener('click', // eslint-disable-next-line func-names
            function () {
              removeShowAll(index);
            }, false);
            item.addEventListener('keydown', function (e) {
              return _utilities.default.keyDownHandler(e, function () {
                return removeShowAll(index);
              }, [_constant.KEY_CODE.ENTER, _constant.KEY_CODE.TAB]);
            });
          });
        }

        if (closeModal && version === 'v1') {
          closeModal.addEventListener('click', visibilityChange);
        }
      }

      document.addEventListener('click', modalHandler);

      if (version === 'v1') {
        document.addEventListener('visibilitychange', visibilityChange);
      }
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', visibilityChange);
    }

    return function () {
      if (typeof document !== 'undefined') {
        document.removeEventListener('click', modalHandler);

        if (version === 'v1') {
          document.removeEventListener('visibilitychange', visibilityChange);
        }
      }

      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', visibilityChange);
      }

      if (typeof showAllTab !== 'undefined' && showAllTab) {
        showAllTab.removeEventListener('click', showAllHandler);
      }
    };
  });
  var noOfTiles = getNumberOFTiles(width);

  if (noOfTiles === 0) {
    if (device === _constants2.DEVICE_TYPE.DESKTOP) {
      noOfTiles = getDefaultNumberOfTiles(length, _constants2.MAX_TILES);
    } else if (device === _constants2.DEVICE_TYPE.TABLET) {
      noOfTiles = getDefaultNumberOfTiles(length, _constants2.MAX_TILES_TABLET);
    }
  }

  var indexToSplit = getIndexToSplit(length, noOfTiles, width);
  arrayToDisplay = getArrayToDisplay(isMobile, showAllFeature, length, props, animationType, device, indexToSplit, eventLabelCardClick, handleGtm, getProductData, shouldFireGTM, productTileData, singleRow);

  if (showAllFeature) {
    splitArrayToDisplay = getSplitArrayToDisplay(isMobile, arrayToDisplay, props, indexToSplit, animationType, device, eventLabelCardClick, handleGtm, getProductData, shouldFireGTM);
  }

  (0, _react.useEffect)(function () {
    if (noOfTiles !== 0 && gtmParameters && !isGtmViewLabelSet && eventLabelView !== '' && width !== 0) {
      var arr = showAllFeature ? splitArrayToDisplay[0] : arrayToDisplay;
      var viewLabel = buildGtmViewEventLabel(arr, showAllFeature);
      handleGtm(null, viewLabel, false);
      setIsGtmViewLabelSet(true);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [noOfTiles]);
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getProductTileWidget(isMobile, showAllFeature, arrayToDisplay, splitArrayToDisplay, theme, animationhandler, modalHandler, ref, openModal, wrapperRef, showAll, device, isIE, zIndex, singleRow, tileItemFlexDirection, tileItemSingleRowGridColumns, visibilityChange, onTrayBlurHandler));
};

ProductTiles.propTypes = _productTiles.default.PropTypes;
ProductTiles.defaultProps = _productTiles.default.defaultProps;
var _default = ProductTiles;
exports.default = _default;